import React, { ChangeEvent, useEffect } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Grid, Typography } from "@mui/material";

interface SkipDatesProps {
  ignoreSkipDates?: boolean;
  handleIgnoreSkipDatesChange(type: string): void;
}

export default function SkipDates({
  ignoreSkipDates,
  handleIgnoreSkipDatesChange,
}: SkipDatesProps) {
  const [skipDates, setSkipDates] = React.useState<string>('');

  const getIgnoreSkipDatesStringValue = (): string => {
    return (ignoreSkipDates ? 'disregard' : 'use'); 
  }

  useEffect(() => {
    if (ignoreSkipDates) {
        setSkipDates(getIgnoreSkipDatesStringValue());
    }
  }, [ignoreSkipDates]);

  useEffect(() => {
    handleIgnoreSkipDatesChange(skipDates);
  }, [skipDates, handleIgnoreSkipDatesChange]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSkipDates(event.target.value);
  };

  return (
    <Grid container size={12}>
      <Grid size={2}>
        <Typography>
          Site Closed Dates
        </Typography>
      </Grid>
      <Grid size={10}>
        <RadioGroup aria-label="site closed dates" value={getIgnoreSkipDatesStringValue()} onChange={handleChange}>
          <FormControlLabel
              value='use'
              control={<Radio />}
              label={<Typography variant='body2'>Skip lesson delivery on closed dates</Typography>}
          />
          <FormControlLabel
              value='disregard'
              control={<Radio />}
              label={<Typography variant='body2'>Always deliver lessons (ignore closed dates)</Typography>}
          />
        </RadioGroup>
        </Grid>
    </Grid>
  );
}